import type { ForwardedRef, FormEventHandler, ReactNode } from 'react';
import React, { forwardRef } from 'react';

import { Form } from '@user-interviews/ui-design-system';

import { useCSRF } from 'hooks/use_csrf';

type DopeFormProps = {
  children?: ReactNode;
  action?: string;
  className?: string;
  id: string;
  method?: string;
  multipart?: string;
  name?: string;
  onSubmit?: FormEventHandler<HTMLFormElement>;
};

export const DopeForm = forwardRef(
  (
    { children, ...props }: DopeFormProps,
    ref: ForwardedRef<HTMLFormElement>,
  ) => {
    const { csrfToken, csrfParam } = useCSRF();

    return (
      <Form {...props} ref={ref}>
        <input name={csrfParam} type="hidden" value={csrfToken} />
        {children}
      </Form>
    );
  },
);
DopeForm.displayName = 'DopeForm';
